// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AdatkezelesiTajekoztatoRouteImport } from './routes/adatkezelesi-tajekoztato'
import { Route as AutoszervizEgerRouteImport } from './routes/autoszerviz-eger'
import { Route as CookieTajekoztatoRouteImport } from './routes/cookie-tajekoztato'
import { Route as FekjavitasEgerRouteImport } from './routes/fekjavitas-eger'
import { Route as FutomuJavitasEgerRouteImport } from './routes/futomu-javitas-eger'
import { Route as GumiszerelesEgerRouteImport } from './routes/gumiszereles-eger'
import { Route as ImpresszumRouteImport } from './routes/impresszum'
import { Route as MotorfelujitasEgerRouteImport } from './routes/motorfelujitas-eger'
import { Route as MotorkerekparSzervizEgerRouteImport } from './routes/motorkerekpar-szerviz-eger'
import { Route as MuszakiVizsgaFelkeszitesEgerRouteImport } from './routes/muszaki-vizsga-felkeszites-eger'
import { Route as PanaszkezelesRouteImport } from './routes/panaszkezeles'
import { Route as SzolgaltatasiFeltetelekRouteImport } from './routes/szolgaltatasi-feltetelek'
import { Route as AdminErtekelesekRouteImport } from './routes/admin/ertekelesek'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AdatkezelesiTajekoztatoRoute = AdatkezelesiTajekoztatoRouteImport.update({
            id: '/adatkezelesi-tajekoztato',path: '/adatkezelesi-tajekoztato',getParentRoute: () => rootRouteImport
          })
const AutoszervizEgerRoute = AutoszervizEgerRouteImport.update({
            id: '/autoszerviz-eger',path: '/autoszerviz-eger',getParentRoute: () => rootRouteImport
          })
const CookieTajekoztatoRoute = CookieTajekoztatoRouteImport.update({
            id: '/cookie-tajekoztato',path: '/cookie-tajekoztato',getParentRoute: () => rootRouteImport
          })
const FekjavitasEgerRoute = FekjavitasEgerRouteImport.update({
            id: '/fekjavitas-eger',path: '/fekjavitas-eger',getParentRoute: () => rootRouteImport
          })
const FutomuJavitasEgerRoute = FutomuJavitasEgerRouteImport.update({
            id: '/futomu-javitas-eger',path: '/futomu-javitas-eger',getParentRoute: () => rootRouteImport
          })
const GumiszerelesEgerRoute = GumiszerelesEgerRouteImport.update({
            id: '/gumiszereles-eger',path: '/gumiszereles-eger',getParentRoute: () => rootRouteImport
          })
const ImpresszumRoute = ImpresszumRouteImport.update({
            id: '/impresszum',path: '/impresszum',getParentRoute: () => rootRouteImport
          })
const MotorfelujitasEgerRoute = MotorfelujitasEgerRouteImport.update({
            id: '/motorfelujitas-eger',path: '/motorfelujitas-eger',getParentRoute: () => rootRouteImport
          })
const MotorkerekparSzervizEgerRoute = MotorkerekparSzervizEgerRouteImport.update({
            id: '/motorkerekpar-szerviz-eger',path: '/motorkerekpar-szerviz-eger',getParentRoute: () => rootRouteImport
          })
const MuszakiVizsgaFelkeszitesEgerRoute = MuszakiVizsgaFelkeszitesEgerRouteImport.update({
            id: '/muszaki-vizsga-felkeszites-eger',path: '/muszaki-vizsga-felkeszites-eger',getParentRoute: () => rootRouteImport
          })
const PanaszkezelesRoute = PanaszkezelesRouteImport.update({
            id: '/panaszkezeles',path: '/panaszkezeles',getParentRoute: () => rootRouteImport
          })
const SzolgaltatasiFeltetelekRoute = SzolgaltatasiFeltetelekRouteImport.update({
            id: '/szolgaltatasi-feltetelek',path: '/szolgaltatasi-feltetelek',getParentRoute: () => rootRouteImport
          })
const AdminErtekelesekRoute = AdminErtekelesekRouteImport.update({
            id: '/admin/ertekelesek',path: '/admin/ertekelesek',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AdatkezelesiTajekoztatoRoute: AdatkezelesiTajekoztatoRoute,AutoszervizEgerRoute: AutoszervizEgerRoute,CookieTajekoztatoRoute: CookieTajekoztatoRoute,FekjavitasEgerRoute: FekjavitasEgerRoute,FutomuJavitasEgerRoute: FutomuJavitasEgerRoute,GumiszerelesEgerRoute: GumiszerelesEgerRoute,ImpresszumRoute: ImpresszumRoute,MotorfelujitasEgerRoute: MotorfelujitasEgerRoute,MotorkerekparSzervizEgerRoute: MotorkerekparSzervizEgerRoute,MuszakiVizsgaFelkeszitesEgerRoute: MuszakiVizsgaFelkeszitesEgerRoute,PanaszkezelesRoute: PanaszkezelesRoute,SzolgaltatasiFeltetelekRoute: SzolgaltatasiFeltetelekRoute,AdminErtekelesekRoute: AdminErtekelesekRoute,AdminLoginRoute: AdminLoginRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)